import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useUnit } from 'effector-react';
import { $cardUsersStore } from '@lib/store/card';
import { $usersListStore } from '@lib/store/users';
import { RoutePaths } from '@shared/utils';
import { UserType } from '@shared/api/rest/users';
import { AddUsersModal, RemoveUsersModal, UserItem } from '@widgets';
import { Button, NoData, Spinner, Text } from '@shared/widgets';

interface IAddUsersProps {
  cardId: string;
}

export const AddUsers = (props: IAddUsersProps) => {
  const usersListStore = useUnit($usersListStore.store);
  const cardUsersStore = useUnit($cardUsersStore.store);

  const [showAddUsersModal, setShowAddUsersModal] = useState<boolean>(false);
  const [showRemoveUsersModal, setShowRemoveUsersModal] = useState<boolean>(false);

  useEffect(() => {
    $cardUsersStore.events.getCardUsers({ AssignedCardId: parseInt(props.cardId) });
    $usersListStore.events.getUsers({ UserType: UserType.USER });
  }, []);

  return (
    <>
      <div className='mb-12'>
        <div className='flex flex-wrap items-center justify-between mb-6'>
          <Text className='pr-4' weight='medium' size='2xl'>
            Users
          </Text>
          <div className='flex items-center'>
            <Button color='outlined' className='mr-3' fullWidth onClick={() => setShowAddUsersModal(true)}>
              Add
            </Button>
            {cardUsersStore.data.length > 0 && (
              <Button color='outlined' onClick={() => setShowRemoveUsersModal(true)}>
                Remove
              </Button>
            )}
          </div>
        </div>
        {cardUsersStore.loading ? (
          <Spinner />
        ) : (
          <div className='flex flex-wrap gap-6'>
            {cardUsersStore.data.length > 0 ? (
              cardUsersStore.data.map((manager, i) => (
                <Link key={i} to={RoutePaths.user.onNavigate(manager.id)}>
                  <UserItem letter={manager.firstName.split('')[0]} name={manager.firstName + ' ' + manager.lastName} />
                </Link>
              ))
            ) : (
              <NoData />
            )}
          </div>
        )}
      </div>
      <AddUsersModal
        show={showAddUsersModal}
        onClose={() => setShowAddUsersModal(false)}
        title='Add users'
        cardId={props.cardId}
        usersList={usersListStore.data.filter((manager) => !cardUsersStore.data?.map((m) => m.id).includes(manager.id))}
      />
      <RemoveUsersModal
        show={showRemoveUsersModal}
        onClose={() => setShowRemoveUsersModal(false)}
        title='Remove Users'
        cardId={props.cardId}
        usersList={cardUsersStore.data}
      />
    </>
  );
};
